export const reviewsLineStyles = {
	display: 'flex',
	alignItems: 'center',
	gap: 0.5,
	flexWrap: 'wrap',
	mt: 1,
};

export const reviewStarsWrapperStyles = {
	position: 'relative',
	display: 'inline-flex',
	alignItems: 'center',
	width: '5rem',
	height: '1rem',
	color: 'warning.main',
};

export const reviewStarsBaseStyles = {
	display: 'inline-flex',
	color: 'neutrals.primary',
};

export const reviewStarsFillStyles = (ratingPercent: number) => ({
	position: 'absolute',
	top: 0,
	left: 0,
	display: 'inline-flex',
	overflow: 'hidden',
	width: `${ratingPercent}%`,
	whiteSpace: 'nowrap',
});

export const reviewStarIconStyles = {
	fontSize: '1rem',
	flexShrink: 0,
};

export const reviewsDrawerStyles = {
	marginTop: '2.5rem',
	marginBottom: '0.938rem',
};
export const loadMoreBoxStyles = {
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
};

export const reviewsDialogStyles = {
	'.MuiPaper-root': {
		height: '42rem',
	},
};

export const pullerContainer = { display: 'flex', justifyContent: 'center' };

export const reviewsDrawerPaperStyles = {
	'& .MuiDrawer-paper': {
		height: '80vh',
		maxHeight: '80vh',
	},
};

export const mobileReviewsContainerStyles = {
	marginTop: '1.375rem',
	height: '100%',
	overflowY: 'auto',
	paddingBottom: '1.5rem',
};

export const oneReviewMobileMargin = { marginRight: '2.813rem' };
export const oneReviewBoxStyles = { display: 'flex', flexDirection: 'column', alignItems: 'flex-start' };
export const oneReviewRatingBoxMargin = { marginBottom: '0.688rem' };
export const oneReviewReadMoreStyles = { cursor: 'pointer', textDecoration: 'underline' };
export const oneReviewSourceMargins = { margin: '0.625rem 0' };
export const oneReviewDividerStyles = { margin: '1.25rem 0 0.625rem' };

export const pointerStyles = { cursor: 'pointer', textDecoration: 'underline' };
export const reviewCountButtonStyles = { ...pointerStyles, background: 'none', border: 0, p: 0 };
